import { FilenameConvention } from 'src/app/models/filename-conventions/filename-convention';

export interface EvConventionCoverage {
  stillsAvailable: boolean;
  videosAvailable: boolean;
}

// FilenameConventionEvEntry does not carry a media discriminator on its selects
// today — the asset model IEnhancementVariantAsset also lacks a media type
// field. Until that shape lands, coverage collapses to a presence check:
// a convention with at least one entry contributes to both media, and an
// entry-less convention contributes to neither. Refine per-media when the
// entry model gains a media discriminator (tracked as a P6+ follow-up).
export const evConventionCoverage = (conventions: FilenameConvention[]): EvConventionCoverage => {
  const anyEntryCarrying = conventions.some(
    (c) => c.value.payload.mode === 'evBased' && c.value.payload.entries.length > 0,
  );
  return {
    stillsAvailable: anyEntryCarrying,
    videosAvailable: anyEntryCarrying,
  };
};
